// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22eBd","label":"styles_label__1hJAD"};